/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type {
  AnyResourceInfo,
  RegionId,
  SliderInstanceType,
  StackDeployment,
} from '@modules/ui-types'
import Feature from '@modules/utils/feature'

import { getFirstSliderClusterFromGet } from '@/lib/stackDeployments/selectors/fundamentals'
import { getStackDeployment } from '@/reducers/stackDeployments'

import { withStackDeploymentRouteParams } from '../StackDeploymentEditor'
import { isFeatureActivated } from '../../selectors'

import StackDeploymentSlider from './StackDeploymentSlider'

import type { ReduxState } from '@/types/redux'
import type { WithStackDeploymentRouteParamsProps } from '../StackDeploymentEditor'

type StateProps = {
  deployment: StackDeployment
  resource: AnyResourceInfo
  regionId: RegionId
  hideDelete: boolean
}

interface DispatchProps {}

type ConsumerProps = WithStackDeploymentRouteParamsProps & {
  sliderInstanceType: SliderInstanceType
}

const mapStateToProps = (
  state: ReduxState,
  { sliderInstanceType, stackDeploymentId, regionId }: ConsumerProps,
): StateProps => {
  const deployment = getStackDeployment(state, stackDeploymentId)!
  const resource = getFirstSliderClusterFromGet({ deployment, sliderInstanceType })!
  const hideDelete =
    sliderInstanceType === `kibana` && isFeatureActivated(state, Feature.hideKibanaDelete)

  return {
    deployment,
    resource,
    regionId,
    hideDelete,
  }
}

export default withStackDeploymentRouteParams(
  connect<StateProps, DispatchProps, ConsumerProps>(mapStateToProps)(StackDeploymentSlider),
)
